module.exports = __webpack_public_path__ + "assets/img/yy.1d9dd3c5.png";